import React, { useEffect, useState, useContext } from 'react';
import { Box, Typography, Button, Paper, Table, TableHead, TableRow, TableCell, TableBody, Dialog, DialogTitle, DialogContent, DialogActions, TextField, IconButton, Tooltip } from '@mui/material';
import { Add, Edit, Delete, Source as SourceIcon } from '@mui/icons-material';
import { useForm, Controller } from 'react-hook-form';
import { ApiContext } from '../contexts/ApiContext';
import { useNotification } from '../contexts/NotificationContext';
import { usePermissions } from '../hooks/usePermissions';

const defaults = { id: undefined, dialplan: '', data: '', custom: true, skill: '' };

export default function DialplansPage(){
  const { dialplans } = useContext(ApiContext);
  const { showSuccess, showError } = useNotification();
  const { canAction } = usePermissions();
  const [rows,setRows]=useState([]);
  const [open,setOpen]=useState(false);
  const [editing,setEditing]=useState(null);
  const { control, handleSubmit, reset, formState:{errors} } = useForm({ defaultValues: defaults });

  const load = async ()=> setRows(await dialplans.getAll());
  useEffect(()=>{ load(); },[]);


  const openDlg=(row=null)=>{ setEditing(row); reset(row? {...defaults,...row}:defaults); setOpen(true); };
  const closeDlg=()=>{ setOpen(false); setEditing(null); };

  const onSubmit = async (values)=>{
    try{
      if(values.id) await dialplans.update(values.id, values);
      else await dialplans.create(values);
      showSuccess(`Dialplan ${values.id?'actualizado':'creado'} y sincronizado`);
      closeDlg(); load();
    }catch(e){ showError(e?.message||'Error al guardar'); }
  };

  const onDelete = async (r)=>{
    if(!window.confirm(`¿Eliminar dialplan "${r.dialplan}"?`)) return;
    try{ await dialplans.remove(r.id); showSuccess('Dialplan eliminado y sincronizado'); load(); }
    catch(e){ showError(e?.message||'Error al eliminar'); }
  };

  return (
    <Box p={2}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <Typography variant="h5" fontWeight={600}>Dialplans</Typography>
        {canAction('create_dialplan') && <Button variant="contained" startIcon={<Add/>} onClick={()=>openDlg(null)}>Nuevo</Button>}
      </Box>

      <Paper>
        <Box p={1} display="flex" gap={1} alignItems="center"><SourceIcon fontSize="small"/><Typography variant="body2">Total: {rows.length}</Typography></Box>
        <Table size="small">
          <TableHead><TableRow><TableCell>Nombre</TableCell><TableCell>Custom</TableCell><TableCell align="right">Acciones</TableCell></TableRow></TableHead>
          <TableBody>
            {rows.map(r=>(
              <TableRow key={r.id} hover>
                <TableCell>{r.dialplan}</TableCell>
                <TableCell>{r.custom ? 'sí':'no'}</TableCell>
                <TableCell align="right">
                  {canAction('edit_dialplan') && <Tooltip title="Editar"><IconButton size="small" onClick={()=>openDlg(r)}><Edit fontSize="small"/></IconButton></Tooltip>}
                  {canAction('delete_dialplan') && <Tooltip title="Eliminar"><IconButton size="small" onClick={()=>onDelete(r)}><Delete fontSize="small"/></IconButton></Tooltip>}
                </TableCell>
              </TableRow>
            ))}
            {rows.length===0 && <TableRow><TableCell colSpan={3} align="center">No hay dialplans.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Paper>

      <Dialog open={open} onClose={closeDlg} maxWidth="md" fullWidth>
        <DialogTitle>{editing?'Editar':'Nuevo'} Dialplan</DialogTitle>
        <DialogContent dividers>
          <Box display="grid" gap={2}>
            <Controller name="dialplan" control={control} rules={{required:'Requerido'}} render={({field})=>(
              <TextField {...field} label="Nombre del Dialplan" fullWidth error={!!errors.dialplan} helperText={errors.dialplan?.message}/>
            )}/>
            <Controller name="data" control={control} rules={{required:'Requerido'}} render={({field})=>(
              <TextField {...field} label="Contenido (bloque completo de dialplan o líneas simples)" multiline minRows={12} fullWidth error={!!errors.data} helperText={errors.data?.message} InputProps={{ style: { fontFamily: 'monospace', fontSize: 13 } }}/>
            )}/>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDlg}>Cancelar</Button>
          <Button variant="contained" onClick={handleSubmit(onSubmit)}>{editing?'Guardar cambios':'Crear'}</Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
}
